export default function BinderBuildersDisclaimer({ style }) {
  return (
    <aside style={{ ...styles.disclaimer, ...style }}>
      B’s Binder Builders is an independent family-run project and is not
      affiliated with, sponsored by, or endorsed by The Pokémon Company,
      Nintendo, Creatures Inc., or Game Freak.
    </aside>
  );
}

const styles = {
  disclaimer: {
    background: "rgba(247, 243, 232, 0.08)",
    border: "1px solid rgba(240, 219, 165, 0.5)",
    borderRadius: 10,
    color: "#D8DEE2",
    fontSize: 13,
    lineHeight: 1.55,
    padding: "14px 16px",
  },
};
